/** 总览：套餐、权益状态、限额。 */
import { useI18n } from '../i18n/context';
import type { Me } from '../lib/api';

export default function Overview({ me }: { me: Me }) {
  const { s } = useI18n();
  const stateText =
    s.overview.state[me.access_state as keyof typeof s.overview.state] ?? me.access_state;

  return (
    <>
      <h1>{s.overview.title}</h1>
      <p className="sub">{s.overview.sub}</p>

      {/* 权益状态是客户最先想知道的事，所以放在最上面且用颜色区分 */}
      {!me.api_access && (
        <div className="banner danger">
          <strong>{s.overview.noAccessTitle}</strong>{' '}
          {me.access_detail || s.overview.noAccessFallback} {s.overview.noAccessHint}
        </div>
      )}
      {me.access_state === 'grace' && (
        <div className="banner">
          <strong>{s.overview.graceTitle}</strong> {me.access_detail}
        </div>
      )}
      {me.access_state === 'trial' && (
        <div className="banner ok">
          <strong>{s.overview.trialTitle}</strong> {me.access_detail}
        </div>
      )}

      <div className="stats">
        <div className="card stat">
          <div className="k">{s.overview.plan}</div>
          <div className="v" style={{ textTransform: 'uppercase' }}>
            {me.plan}
          </div>
        </div>
        <div className="card stat">
          <div className="k">{s.overview.apiAccess}</div>
          <div className="v" style={{ color: me.api_access ? 'var(--up)' : 'var(--danger)' }}>
            {stateText}
          </div>
        </div>
        <div className="card stat">
          <div className="k">{s.overview.rpm}</div>
          <div className="v">
            {me.limits?.requests_per_minute.toLocaleString() ?? s.common.dash}
          </div>
        </div>
        <div className="card stat">
          <div className="k">{s.overview.rpd}</div>
          <div className="v">{me.limits?.requests_per_day.toLocaleString() ?? s.common.dash}</div>
        </div>
      </div>

      {me.limits && (
        <>
          <h2>{s.overview.limitsTitle}</h2>
          <div className="card" style={{ padding: 0 }}>
            <table>
              <tbody>
                <tr>
                  <td style={{ color: 'var(--ink-soft)' }}>{s.overview.symbolsPerRequest}</td>
                  <td className="mono">{me.limits.symbols_per_request}</td>
                </tr>
                <tr>
                  <td style={{ color: 'var(--ink-soft)' }}>{s.overview.lookback}</td>
                  <td className="mono">
                    {me.limits.max_lookback_days === null
                      ? s.overview.fullHistory
                      : s.overview.lookbackDays(me.limits.max_lookback_days)}
                  </td>
                </tr>
                <tr>
                  <td style={{ color: 'var(--ink-soft)' }}>{s.overview.maxKeys}</td>
                  <td className="mono">{me.limits.max_keys}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      <h2>{s.overview.quickstart}</h2>
      <div className="card">
        <div className="secret" style={{ whiteSpace: 'pre-wrap' }}>
          {`curl -H "Authorization: Bearer $SQUAWK_API_KEY" \\
  "https://api.squawkquant.com/v1/bars/1m/AAPL?start=2026-08-19&end=2026-08-19"`}
        </div>
        <p style={{ color: 'var(--ink-dim)', fontSize: 13.5, margin: '14px 0 0' }}>
          {s.overview.quickstartNote}
        </p>
      </div>
    </>
  );
}
